// eslint-ignore-file
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyD3MrTjrqCP0EUvisLZqpjJEPye7fP8FLw",
  version: "weekly",
});

const places = async () => {
  return await loader.importLibrary("places");
};

const geocoding = async () => {
  return await loader.importLibrary("geocoding");
};

const div = document.createElement("div");

export async function searchPlace(
  query: string,
  location: google.maps.LatLng | google.maps.LatLngLiteral | null = null
): Promise<google.maps.places.PlaceResult[]> {
  return new Promise(async (resolve, reject) => {
    try {
      const service = new (await places()).PlacesService(div);
      service.textSearch(
        { query, location: location || undefined },
        (
          results: google.maps.places.PlaceResult[] | null,
          status: google.maps.places.PlacesServiceStatus
        ) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            resolve(results);
          } else {
            reject(new Error(`Places service failed with status: ${status}`));
          }
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}

export async function getPlace(placeId: string): Promise<google.maps.places.PlaceResult> {
  return new Promise(async (resolve, reject) => {
    try {
      const service = new (await places()).PlacesService(div);
      service.getDetails(
        { placeId },
        (
          result: google.maps.places.PlaceResult | null,
          status: google.maps.places.PlacesServiceStatus
        ) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && result) {
            resolve(result);
          } else {
            reject(new Error(`Place details service failed with status: ${status}`));
          }
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}

export async function getGeocode(placeId: string): Promise<google.maps.GeocoderResult> {
  return new Promise(async (resolve, reject) => {
    try {
      const geocoder = new (await geocoding()).Geocoder();
      geocoder.geocode(
        { placeId },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
            resolve(results[0]);
          } else {
            reject(new Error(`Geocoding service failed with status: ${status}`));
          }
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}

export async function getGeocodeByText(
  text: string,
  locality: string,
  number: string | number
): Promise<google.maps.GeocoderResult> {
  return new Promise(async (resolve, reject) => {
    try {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: `${text}, ${number}, ${locality}` },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
            resolve(results[0]);
          } else {
            reject(new Error(`Geocoding service failed with status: ${status}`));
          }
        }
      );
    } catch (e) {
      reject(e);
    }
  });
}
